import { graphql } from "@opensea/graphql"
import { CreateOrdersSummaryFragment } from "../../../../../components/CreateOrdersSummary/CreateOrdersSummary.fragment"
import { CreateOfferFlowTableFragment } from "../CreateOfferFlowTable/CreateOfferFlowTable.fragment"

export const CreateOfferForm_itemFragment = graphql(
  `
    fragment CreateOfferForm_item on Item {
      id
      ...CreateOfferFlowTable
      collection {
        chain {
          identifier
          nativeCurrency {
            address
          }
          offerCurrency {
            address
            symbol
          }
        }
        ...CreateOrdersSummary
      }
    }
  `,
  [CreateOfferFlowTableFragment, CreateOrdersSummaryFragment],
)
